import React from 'react';
import styles from 'feature/street-parking/index.module.sass';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import PageLayout from 'layout/page';
import StreetParkingLayout from 'layout/street-parking';
import CardItem from 'components/card-item';
import Icon from 'components/icon';
import LoadingDialog from 'components/loading-dialog';
import { vehicleHelper } from 'helpers/vehicle-helper';
import iconCircleArrowRight from 'assets/icon_circle_arrow_right.svg';
import { useAppContext } from 'use-app';
import get from 'lodash/get';
import { PATH } from 'config';

const StreetParkingPlates = () => {
  const { state: appState } = useAppContext();
  const history = useHistory();
  const location = useLocation();
  const cityParams = qs.parse(location.search);
  const licensePlates = get(appState, 'licensePlates', []);
  const maxVehicleCount = get(appState, 'me.maxVehicleCount', 3);

  const Loading = () => {
    if (appState.loading) {
      return <LoadingDialog />;
    } else {
      return <></>;
    }
  };

  const PlateCardItem = ({ plate, isSelected }) => {
    const bgColor = isSelected ? 'bgBlue' : '';
    return (
      <div className={styles.card}>
        <CardItem
          bgColor={bgColor}
          content={`${plate.plateNumber} / ${vehicleHelper(plate.vehicleType)}`}
          onClick={() => {
            history.replace({
              pathname: PATH.STREET_PARKING_BILLS,
              search: `city=${cityParams.city}&plate=${plate.plateNumber}`,
            });
          }}
        />
      </div>
    );
  };

  const AddNewPlate = () => {
    if (maxVehicleCount > licensePlates.length) {
      return (
        <CardItem
          fontColor="blue"
          content="加入付款車牌"
          rightContent={<Icon imgSrc={iconCircleArrowRight} height="20px" alt="icon-cricle-arrow-right" />}
          onClick={() => {
            history.push(PATH.LICENSE_PLATES_NEW);
          }}
        />
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Loading />
      <PageLayout>
        <StreetParkingLayout className={styles.cities}>
          <div className={styles.title}>請選擇一張車牌</div>
          <div className={styles.plates}>
            {licensePlates.map(plate => {
              return <PlateCardItem key={plate.id} plate={plate} />;
            })}
            <AddNewPlate />
          </div>
        </StreetParkingLayout>
      </PageLayout>
    </>
  );
};

export default StreetParkingPlates;
